<div class="p-grid">
    <div class="p-col-12 page-header">Office</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-6 p-lg-2 p-md-2 p-sm-2" *ngIf="canEditMember">
        <button pButton type="submit" class="fullwidthbtn" label="Edit Member Info" routerLink="/member/edit/{{member.Id}}"></button>
    </div>
    <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="canEditMemberTerritory">
        <button pButton type="button" class="fullwidthbtn" label="Edit Territories" routerLink="/member/editterritory/{{member.Id}}"></button>
    </div>
</div>
<div class="card">         
    <div class="p-grid">       
        <div class="p-col-12 p-md-6 p-lg-6">
            <div class="p-col-12" *ngIf="member.Active==false">
                <p-message severity="warn" text="This member has been terminated." styleClass="mr-2"></p-message>
            </div>
            <div class="message-header">
                {{member.Name}}
            </div>
            <div class="message-caption">
                <div class="p-col-12" *ngIf="member.Address"><strong>Address: </strong>{{member.Address}}<span *ngIf="member.Address2">{{' ' + member.Address2}}</span></div>
                <div class="p-col-12">
                    <span *ngIf="member.City">{{member.City}}</span>
                    <span *ngIf="member.StatesName">{{", " + member.StatesName}}</span>
                    <span *ngIf="member.CountriesName">{{", " + member.CountriesCode}}</span>
                    <span *ngIf="member.PostalCode">{{", " + member.PostalCode}}</span>
                </div>

                <div class="p-col-12" *ngIf="member.OfficePhone"><strong>Office Phone: </strong>{{member.OfficePhone}}</div>
                <div class="p-col-12" *ngIf="member.OfficeFax"><strong>Fax: </strong>{{member.OfficeFax }}</div>
                <div class="p-col-12 hyperlink" *ngIf="member.OfficeWebsite"><strong>Website: </strong><a target="_blank" [href]="formatUrl(member.OfficeWebsite)">{{formatUrlforDisplay(member.OfficeWebsite)}}</a></div>
                <div class="p-col-12" *ngIf="member.FacebookID||member.TwitterID||member.YoutubeID||member.GooglePlusID||member.LinkedINID||member.BlogUrl||member.BlogRSSFeedUrl">
                    <a target="_blank" *ngIf="member.FacebookID" href="https://www.facebook.com/{{member.FacebookID}}"><img src="assets/layout/images/naiimages/social/facebook.jpg"  style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.TwitterID" href="https://twitter.com/{{member.TwitterID}}"><img src="assets/layout/images/naiimages/social/twitter.jpg" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.YoutubeID" href="https://www.youtube.com/channel/{{member.YoutubeID}}"><img src="assets/layout/images/naiimages/social/youtube.jpg" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.Instagram" href="https://www.instagram.com/{{member.Instagram}}"><img src="assets/layout/images/naiimages/social/instagram.jpg" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.LinkedINID" href="https://www.linkedin.com/in/{{member.LinkedInURL}}"><img src="assets/layout/images/naiimages/social/linkedin.jpg" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.BlogUrl" href="{{member.BlogUrl}}"><img src="assets/layout/images/naiimages/social/blog.jpg" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                    <a target="_blank" *ngIf="member.BlogRSSFeedUrl" href="{{member.BlogRSSFeedUrl}}"><img src="assets/layout/images/naiimages/social/rss.png" style="max-height: 20px; max-width: 20px; margin-left: 5px;" /></a>
                </div>
            </div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-6">
            <img [src]="member.Logo" height="65" style="max-width: 100%;
            max-height: 100%;"/>
        </div>
        <!-- <div class="p-col-12 p-md-6 p-lg-6">
            <div class="p-col-12">
                <div class="p-col-12 p-md-6 p-lg-6">                 
                    <img [src]="member.Logo" width="450"/>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6">
                    <img [src]="member.Icon" width="50" />
                </div>
            </div>
            
        </div> -->

        <div class="p-col-12">
            <p-tabView (onChange)="onTabOpen($event)" [(activeIndex)]="currentTab">
                <p-tabPanel header="Profile">
                    <div class="">
                        <div class="" *ngIf="member.Profile">
                            <div class="message-header-small">Profile</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.Profile}}"></div>
                        </div>
                        <div class="" *ngIf="member.AboutUs">
                            <div class="message-header-small">About Us</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.AboutUs}}"></div>
                        </div>
                        <div class="" *ngIf="member.MarketAreaDescription">
                            <div class="message-header-small">Market Area Description</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.MarketAreaDescription}}"></div>
                        </div>
                        <div class="" *ngIf="member.ProfessionalDesignations">
                            <div class="message-header-small">Professional Designations</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.ProfessionalDesignations}}"></div>
                        </div>
                        <div class="" *ngIf="member.BrokerageServices">
                            <div class="message-header-small">Services Offered</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.BrokerageServices}}"></div>
                        </div>
                        <div class="" *ngIf="member.OtherServices">
                            <div class="message-header-small">Other Services</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.OtherServices}}"></div>
                        </div>
                        <div class="" *ngIf="member.ExclusivityArea">
                            <div class="message-header-small">Exclusivity Area</div>
                            <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{member.ExclusivityArea}}"></div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Office Locations">
                    <div class="card" [hidden]="!IsOfficeLocationDataTableVisible()">
                        <p-table [value]="officelocations"
                                 dataKey="Id"
                                 [paginator]="IsPaginatorOffLocationVisible()"
                                 paginatorPosition="both"
                                 [rows]="20"
                                 [responsive]="true"
                                 [resizableColumns]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pResizableColumn>
                                        Name
                                    </th>
                                    <th *ngFor="let col of officeCols" [pSortableColumn]="col.field" [ngStyle]="{'display': col.display, 'width' : col.width}" pResizableColumn>
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr [pRowToggler]="rowData" [pSelectableRow]="rowData">
                                    <td>
                                        <p-button label=" {{rowData.Name}}" styleClass="p-button-link" (click)="navToMemberProfile(rowData.Id)"></p-button>
                                    </td>
                                    <td *ngFor="let col of officeCols" [ngStyle]="{'display': col.display, 'width' : col.width}" class="ui-resizable-column">
                                        {{FormatColumnData(rowData[col.field], col.field)}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Office Contacts">
                    <div class="card" [hidden]="!IsAgentStaffDataTableVisible()">
                        <p-table [value]="member.AgentsAndStaff"
                                 dataKey="Id"
                                 [rows]="20"
                                 [responsive]="true"
                                 [resizableColumns]="true">
                            <ng-template pTemplate="header">

                                <tr>
                                    <th [style.width]="'5%'" pResizableColumn>

                                    </th>
                                    <th [style.width]="'45%'" pResizableColumn>

                                    </th>
                                    <th [style.width]="'20%'" pResizableColumn>
                                        Direct Phone
                                    </th>
                                    <th [style.width]="'20%'" pResizableColumn>
                                        Email
                                    </th>
                                    <th [style.width]="'10%'" pResizableColumn>
                                        vCard
                                    </th>
                                </tr>

                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr [pRowToggler]="rowData" [pSelectableRow]="rowData" *ngIf="rowData.IsOfficeLeader">
                                    <td>
                                        <img class="ng-tns-c2-0" alt="" [src]="getUserImageSrc(rowData)" style="width: 36px; height: 36px;">
                                    </td>
                                    <td style="word-wrap: break-word;">

                                        <p-button label={{getUserFullName(rowData)}} styleClass="p-button-link" (click)="navToUserProfile(rowData.Id)"></p-button>
                                        <br>
                                        <b>Roles:</b> {{rowData.OfficeRoles}}
                                        <br>
                                        <span *ngIf="rowData.IsApprovingManager">
                                            <b>
                                                Approving Manager:<i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                                                                     [ngStyle]="{'color': (rowData.IsApprovingManager) ? '#D99F00' : '#E1E3E3'}">
                                                </i>
                                            </b>
                                        </span>
                                    </td>
                                    <td>
                                        {{rowData.DirectPhone}} <span *ngIf="rowData.DirectPhoneExtn!= null &&  rowData.DirectPhoneExtn!= ''"> Extn: {{rowData.DirectPhoneExtn}}</span>
                                    </td>
                                    <td>
                                        <p-button label="{{rowData.Email}}" styleClass="p-button-link" (click)="NavMailto(rowData.Email)"></p-button>
                                    </td>
                                    <td>
                                        <input *ngIf="rowData.VCard" class="imageButton" type="image" src="assets/layout/images/naiimages/card-address.png" (click)="downloadVCard(rowData.VCard)">
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Agents and Staff">
                    <div class="card" [hidden]="!IsAgentStaffDataTableVisible()">
                        <p-table [value]="member.AgentsAndStaff"
                                 dataKey="Id"
                                 [paginator]="IsPaginatorAgentStaffVisible()"
                                 paginatorPosition="bottom"
                                 [rows]="20"
                                 [responsive]="true"
                                 [resizableColumns]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th [style.width]="'5%'" pResizableColumn>

                                    </th>
                                    <th [style.width]="'45%'" pResizableColumn>

                                    </th>
                                    <th [style.width]="'20%'" pResizableColumn>
                                        Direct Phone
                                    </th>
                                    <th [style.width]="'20%'" pResizableColumn>
                                        Email
                                    </th>
                                    <th [style.width]="'10%'" pResizableColumn>
                                        vCard
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr [pRowToggler]="rowData" [pSelectableRow]="rowData">
                                    <td>
                                        <img class="ng-tns-c2-0" alt="" [src]="getUserImageSrc(rowData)" style="width: 36px; height: 36px;">
                                    </td>
                                    <td style="word-wrap: break-word;">
                                        <p-button label={{getUserFullName(rowData)}} styleClass="p-button-link" (click)="navToUserProfile(rowData.Id)"></p-button>
                                        <br>
                                        <span *ngIf="rowData.Title"><b>Title:</b> {{rowData.Title}}</span>

                                        <span *ngIf="rowData.PrimarySpecialty"><br><b>Specialty:</b> {{rowData.PrimarySpecialty}}</span>

                                        <span *ngIf="rowData.IsApprovingManager">
                                            <br><b>
                                                Approving Manager:<i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                                                                     [ngStyle]="{'color': (rowData.IsApprovingManager) ? '#D99F00' : '#E1E3E3'}">
                                                </i>
                                            </b>
                                        </span>
                                    </td>
                                    <td>
                                        {{rowData.DirectPhone}} <span *ngIf="rowData.DirectPhoneExtn!= null &&  rowData.DirectPhoneExtn!= ''"> Extn: {{rowData.DirectPhoneExtn}}</span>
                                    </td>
                                    <td>
                                        <p-button label="{{rowData.Email}}" styleClass="p-button-link" (click)="NavMailto(rowData.Email)"></p-button>
                                    </td>
                                    <td>
                                        <input *ngIf="rowData.VCard" class="imageButton" type="image" src="assets/layout/images/naiimages/card-address.png" (click)="downloadVCard(rowData.VCard)">
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Territories">
                   <div>
                    <div class="p-col-12 error-notify-text" *ngIf="territories.length == 0">
                        There are no territories for this member office
                    </div>
                   </div>
                   <div *ngIf="territories.length>0">
                        <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
                            <agm-kml-layer [url]="kmlurl" [preserveViewport]="false"> </agm-kml-layer>
                        </agm-map>
                        <div class="p-grid">               
                            <div class="p-col-12">
                                <p-table [value]="territories" responsiveLayout="scroll">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th><b>Territory Name</b></th>                                        
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-territory>
                                        <tr>
                                            <td>{{territory.TerritoryName}}</td>                                                             
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                  </div>  
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>
